"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareComponent = void 0;
const base_component_1 = require("../base-component");
class ShareComponent extends base_component_1.BaseComponent {
    mountComponent() {
        this.addListener(this, 'click', this.handleClick);
    }
    handleClick = (event) => {
        event.preventDefault();
        if (navigator.share) {
            navigator.share({ text: this.dataset.valueToCopy });
        }
    };
}
exports.ShareComponent = ShareComponent;
